/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainCertificationReviewType = 'TeacherRegistration' | 'WorkingWithChildrenCheck' | 'Qualification' | 'Training' | 'Vaccination' | 'PoliceCheck';

export const DomainCertificationReviewType = {
    TeacherRegistration: 'TeacherRegistration' as DomainCertificationReviewType,
    WorkingWithChildrenCheck: 'WorkingWithChildrenCheck' as DomainCertificationReviewType,
    Qualification: 'Qualification' as DomainCertificationReviewType,
    Training: 'Training' as DomainCertificationReviewType,
    Vaccination: 'Vaccination' as DomainCertificationReviewType,
    PoliceCheck: 'PoliceCheck' as DomainCertificationReviewType
};